import { styled } from "@mui/material/styles";

export const ItemsWrapper = styled("div", {
  label: "items-wrapper",
})`
${({ theme }) => theme.breakpoints.up("md")} {
  margin-bottom: ${({ theme }) => theme.spacing(2.5)}; 
  padding-bottom: ${({ theme }) => theme.spacing(2.5)}; 
}
   &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.color.gray[80]};
`;
export const WhatsCoveredContainer = styled("div", {
  label: "whats-covered-container",
})`
  padding: ${({ theme }) => theme.spacing(4, -2, 0)};
`;
